import {index, reduce} from '@republic/foundation/lang/array'
import {keys} from '@republic/foundation/lang/object'

const
    omit = (obj, properties) => (
        reduce(
            keys(obj),
            (memo, key) => {
                if (index(properties, prop => prop === key) === -1) {
                    memo[key] = obj[key]
                }
                return memo
            },
            {}))

export {omit}
